/* eslint-disable */
import React from 'react';
import { useParams } from 'react-router-dom';
import { useUpdateComponentState } from '../../../hooks';
import MisconceptionCards, {
  PSA_CARD_ICONS,
} from '../../components/MisconceptionCards';
import WhyStudentTargetReasons from '../../components/WhyStudentTargetReasons';
interface ISection1Props {
  settings: any;
}

const Section1: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '2';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = React.useMemo(
    () => settings?.paragraphs[1],
    [settings?.paragraphs]
  );
  const updateComponentState = useUpdateComponentState();
  const handleMisconceptionCardsComplete = React.useCallback(() => {
    updateComponentState(
      p_course,
      p_topic,
      ID,
      'student-training-psa-section1-1'
    );
  }, [updateComponentState, p_course, p_topic, ID]);
  // const onWhyComplete = React.useCallback(() => {
  //   updateComponentState(p_course, p_topic, ID, 'student-training-psa-section1-2');
  // }, [updateComponentState, p_course, p_topic, ID]);

  const bestPractice = paragraphsSettings?.bestPractice;
  return (
    <div className="topic-section-1">
      <div className="risks">
        <h1 className="risks-title">{paragraphsSettings?.title}</h1>
        <h1 className="risks-sub-title">{paragraphsSettings?.risksSubTitle}</h1>
      </div>
      <MisconceptionCards
        title={paragraphsSettings?.risksTitle}
        items={paragraphsSettings?.risks}
        tips={paragraphsSettings?.risksTips}
        icons={PSA_CARD_ICONS}
        id="student-training-psa-section1-1"
        onComplete={handleMisconceptionCardsComplete}
      />
      {bestPractice ? (
        <WhyStudentTargetReasons
          title={bestPractice.title}
          description={bestPractice.description}
          items={bestPractice.items}
        />
      ) : null}
    </div>
  );
};

export default Section1;
